var _linearGradient, _linearGradient2, _path, _linearGradient3, _path2, _linearGradient4, _path3, _linearGradient5, _path4, _linearGradient6, _path5, _linearGradient7, _path6, _linearGradient8, _path7, _linearGradient9, _path8, _linearGradient10, _path9, _linearGradient11, _path10, _linearGradient12, _path11, _linearGradient13, _path12, _linearGradient14, _path13, _linearGradient15, _path14, _linearGradient16, _path15, _linearGradient17, _path16, _linearGradient18, _path17, _linearGradient19, _path18, _linearGradient20, _path19, _linearGradient21, _path20, _linearGradient22, _path21, _path22, _path23, _path24, _path25, _path26;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtherLiability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.425 198.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_5ae8bc728800802fbb29e64292e3c9287fce1b8f1e2562ac40b9a56a6c78bfef",
    gradientUnits: "userSpaceOnUse",
    x1: -499.146,
    y1: -724.509,
    x2: -498.146,
    y2: -724.509
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_5ae8bc728800802fbb29e64292e3c9287fce1b8f1e2562ac40b9a56a6c78bfef",
    gradientUnits: "userSpaceOnUse",
    x1: 75.181,
    y1: 48.24,
    x2: 85.553,
    y2: 48.24
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_1_5ae8bc728800802fbb29e64292e3c9287fce1b8f1e2562ac40b9a56a6c78bfef)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M84.304 44.304l-7.873 7.872"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_5ae8bc728800802fbb29e64292e3c9287fce1b8f1e2562ac40b9a56a6c78bfef",
    gradientUnits: "userSpaceOnUse",
    x1: 75.181,
    y1: 55.273,
    x2: 99.609,
    y2: 55.273
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_2_5ae8bc728800802fbb29e64292e3c9287fce1b8f1e2562ac40b9a56a6c78bfef)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M98.359 44.304L76.431 66.242"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_5ae8bc728800802fbb29e64292e3c9287fce1b8f1e2562ac40b9a56a6c78bfef",
    gradientUnits: "userSpaceOnUse",
    x1: 75.181,
    y1: 61.638,
    x2: 112.35,
    y2: 61.638
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_3_5ae8bc728800802fbb29e64292e3c9287fce1b8f1e2562ac40b9a56a6c78bfef)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M111.1 44.304L76.431 78.972"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_5ae8bc728800802fbb29e64292e3c9287fce1b8f1e2562ac40b9a56a6c78bfef",
    gradientUnits: "userSpaceOnUse",
    x1: 75.181,
    y1: 68.459,
    x2: 125.992,
    y2: 68.459
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_4_5ae8bc728800802fbb29e64292e3c9287fce1b8f1e2562ac40b9a56a6c78bfef)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M124.742 44.304L76.431 92.615"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_5ae8bc728800802fbb29e64292e3c9287fce1b8f1e2562ac40b9a56a6c78bfef",
    gradientUnits: "userSpaceOnUse",
    x1: 80.926,
    y1: 79.427,
    x2: 126.438,
    y2: 79.427
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_5_5ae8bc728800802fbb29e64292e3c9287fce1b8f1e2562ac40b9a56a6c78bfef)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M125.188 57.921l-43.012 43.012"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_5ae8bc728800802fbb29e64292e3c9287fce1b8f1e2562ac40b9a56a6c78bfef",
    gradientUnits: "userSpaceOnUse",
    x1: 88.828,
    y1: 88.832,
    x2: 126.438,
    y2: 88.832
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_6_5ae8bc728800802fbb29e64292e3c9287fce1b8f1e2562ac40b9a56a6c78bfef)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M125.188 71.276l-35.11 35.111"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_5ae8bc728800802fbb29e64292e3c9287fce1b8f1e2562ac40b9a56a6c78bfef",
    gradientUnits: "userSpaceOnUse",
    x1: 96.902,
    y1: 98.447,
    x2: 126.438,
    y2: 98.447
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_7_5ae8bc728800802fbb29e64292e3c9287fce1b8f1e2562ac40b9a56a6c78bfef)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M125.188 84.929l-27.036 27.036"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_5ae8bc728800802fbb29e64292e3c9287fce1b8f1e2562ac40b9a56a6c78bfef",
    gradientUnits: "userSpaceOnUse",
    x1: 75.181,
    y1: 78.134,
    x2: 126.438,
    y2: 78.134
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_8_5ae8bc728800802fbb29e64292e3c9287fce1b8f1e2562ac40b9a56a6c78bfef)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M84.304 44.304l-7.873 7.872"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_5ae8bc728800802fbb29e64292e3c9287fce1b8f1e2562ac40b9a56a6c78bfef",
    gradientUnits: "userSpaceOnUse",
    x1: 75.181,
    y1: 78.134,
    x2: 126.438,
    y2: 78.134
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_9_5ae8bc728800802fbb29e64292e3c9287fce1b8f1e2562ac40b9a56a6c78bfef)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M84.304 44.304l-7.873 7.872"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_5ae8bc728800802fbb29e64292e3c9287fce1b8f1e2562ac40b9a56a6c78bfef",
    gradientUnits: "userSpaceOnUse",
    x1: 75.181,
    y1: 78.134,
    x2: 126.438,
    y2: 78.134
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_10_5ae8bc728800802fbb29e64292e3c9287fce1b8f1e2562ac40b9a56a6c78bfef)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M98.359 44.304L76.431 66.242"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_5ae8bc728800802fbb29e64292e3c9287fce1b8f1e2562ac40b9a56a6c78bfef",
    gradientUnits: "userSpaceOnUse",
    x1: 75.181,
    y1: 78.134,
    x2: 126.438,
    y2: 78.134
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_11_5ae8bc728800802fbb29e64292e3c9287fce1b8f1e2562ac40b9a56a6c78bfef)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M98.359 44.304L76.431 66.242"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_5ae8bc728800802fbb29e64292e3c9287fce1b8f1e2562ac40b9a56a6c78bfef",
    gradientUnits: "userSpaceOnUse",
    x1: 75.181,
    y1: 78.134,
    x2: 126.438,
    y2: 78.134
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_12_5ae8bc728800802fbb29e64292e3c9287fce1b8f1e2562ac40b9a56a6c78bfef)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M111.1 44.304L76.431 78.972"
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_5ae8bc728800802fbb29e64292e3c9287fce1b8f1e2562ac40b9a56a6c78bfef",
    gradientUnits: "userSpaceOnUse",
    x1: 75.181,
    y1: 78.134,
    x2: 126.438,
    y2: 78.134
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_13_5ae8bc728800802fbb29e64292e3c9287fce1b8f1e2562ac40b9a56a6c78bfef)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M111.1 44.304L76.431 78.972"
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_5ae8bc728800802fbb29e64292e3c9287fce1b8f1e2562ac40b9a56a6c78bfef",
    gradientUnits: "userSpaceOnUse",
    x1: 75.181,
    y1: 78.134,
    x2: 126.438,
    y2: 78.134
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_14_5ae8bc728800802fbb29e64292e3c9287fce1b8f1e2562ac40b9a56a6c78bfef)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M124.742 44.304L76.431 92.615"
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_5ae8bc728800802fbb29e64292e3c9287fce1b8f1e2562ac40b9a56a6c78bfef",
    gradientUnits: "userSpaceOnUse",
    x1: 75.181,
    y1: 78.134,
    x2: 126.438,
    y2: 78.134
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_15_5ae8bc728800802fbb29e64292e3c9287fce1b8f1e2562ac40b9a56a6c78bfef)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M124.742 44.304L76.431 92.615"
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_5ae8bc728800802fbb29e64292e3c9287fce1b8f1e2562ac40b9a56a6c78bfef",
    gradientUnits: "userSpaceOnUse",
    x1: 75.181,
    y1: 78.134,
    x2: 126.438,
    y2: 78.134
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_16_5ae8bc728800802fbb29e64292e3c9287fce1b8f1e2562ac40b9a56a6c78bfef)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M125.188 57.921l-43.012 43.012"
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_5ae8bc728800802fbb29e64292e3c9287fce1b8f1e2562ac40b9a56a6c78bfef",
    gradientUnits: "userSpaceOnUse",
    x1: 75.181,
    y1: 78.134,
    x2: 126.438,
    y2: 78.134
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_17_5ae8bc728800802fbb29e64292e3c9287fce1b8f1e2562ac40b9a56a6c78bfef)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M125.188 57.921l-43.012 43.012"
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_5ae8bc728800802fbb29e64292e3c9287fce1b8f1e2562ac40b9a56a6c78bfef",
    gradientUnits: "userSpaceOnUse",
    x1: 75.181,
    y1: 78.134,
    x2: 126.438,
    y2: 78.134
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_18_5ae8bc728800802fbb29e64292e3c9287fce1b8f1e2562ac40b9a56a6c78bfef)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M125.188 71.276l-35.11 35.111"
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_5ae8bc728800802fbb29e64292e3c9287fce1b8f1e2562ac40b9a56a6c78bfef",
    gradientUnits: "userSpaceOnUse",
    x1: 75.181,
    y1: 78.134,
    x2: 126.438,
    y2: 78.134
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_19_5ae8bc728800802fbb29e64292e3c9287fce1b8f1e2562ac40b9a56a6c78bfef)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M125.188 71.276l-35.11 35.111"
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_5ae8bc728800802fbb29e64292e3c9287fce1b8f1e2562ac40b9a56a6c78bfef",
    gradientUnits: "userSpaceOnUse",
    x1: 75.181,
    y1: 78.134,
    x2: 126.438,
    y2: 78.134
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_20_5ae8bc728800802fbb29e64292e3c9287fce1b8f1e2562ac40b9a56a6c78bfef)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M125.188 84.929l-27.036 27.036"
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_5ae8bc728800802fbb29e64292e3c9287fce1b8f1e2562ac40b9a56a6c78bfef",
    gradientUnits: "userSpaceOnUse",
    x1: 75.181,
    y1: 78.134,
    x2: 126.438,
    y2: 78.134
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_21_5ae8bc728800802fbb29e64292e3c9287fce1b8f1e2562ac40b9a56a6c78bfef)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M125.188 84.929l-27.036 27.036"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M156.218 123.035v16.331H45.856v-16.331M156.218 123.035V75.866l-17.531-12.261M62.705 64.076l-16.849 11.79v47.169M62.708 87.501V54.756M138.683 87.794V63.602"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M156.218 75.866L138.687 87.79l-16.101 10.935-.95.643-14.517 9.88-5.856 3.984-.644.432-2.467-1.699-3.937-2.717-4.137-2.861-7.902-5.454-2.227-1.536-17.244-11.895-16.849-11.636M156.218 123.035v16.331H45.856v-16.331"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M156.218 123.035V75.866l-17.531-12.261M62.705 64.076l-16.849 11.79v47.169M62.708 87.501V54.756M138.683 87.794V63.602"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M156.218 75.866L138.687 87.79l-16.101 10.935-.95.643-14.517 9.88-5.856 3.984-.644.432-2.467-1.699-3.937-2.717-4.137-2.861-7.902-5.454-2.227-1.536-17.244-11.895-16.849-11.636M62.681 54.756H44.987V38.085c0-4.701 3.984-8.549 8.842-8.549 4.868 0 8.852 3.848 8.852 8.549v16.671z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M54.074 29.367h75.79c4.868 0 8.852 3.85 8.852 8.545v25.69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherLiability);
export default __webpack_public_path__ + "static/media/otherLiability.44bce6dbb06521ea8524e3f1526fff22.svg";
export { ForwardRef as ReactComponent };